import type { FaireProductEntity } from "../../entity_types/product";

export const p_bytd339vsh: FaireProductEntity = {
  token: "p_bytd339vsh",
  type: "product",
  name: "Ghost Claw Clip - Large",
  brandToken: "b_jcn5s8r6ur",
  brandName: "Adorro",
  imageUrl:
    "https://cdn.faire.com/fastly/25cbed5fcfd34f7068a60eb30bf998b948ea61d42a1245bf95b70e5da6e18a5e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4f9665221a6f151796390321fe82f368bf9fa10093449109640d14571799ec4.jpeg",
    "https://cdn.faire.com/fastly/d0e860ce720118f8e86eb93697853f2e2147eade363748d6f74907b0ca0f992b.jpeg",
    "https://cdn.faire.com/fastly/a5ce4db34390f3df36b5871ea81f9f6dfc5132189553c506e569e4e7080f41da.jpeg",
    "https://cdn.faire.com/fastly/b0571ef5b06b008b08af54db9f3e061887b8f8c62df06199d8aac0b01fdf3688.jpeg",
    "https://cdn.faire.com/fastly/612fcdfa977597026c4f16f9000e2e0077de740ff7fc051821a623191edfbc7e.jpeg",
    "https://cdn.faire.com/fastly/f82c7dabb5d20a89af167c6371014b077bfcfe33f94cf407cc07088e6af04cdc.jpeg",
  ],
  priceDollars: 8,
  description:
    "Ghost \nLarge (3.3 inch)\nAdorro Exclusive: designed in Chicago\n\nSpooky season is here with our pearl Ghost claw. Perfect for Halloween \nMade with eco-friendly material that is both durable and comfortable. \n\nMeasurements: \n8.3cm x 6cm\n\nMaterials: Cellulose Acetate (eco-friendly material)\nCellulose Acetate is a synthetic fiber produced from plant derivatives such as wood pulp and cotton. CA is both durable and biodegradable. Compared to acrylic and PVC materials, you will see that our clips will last you longer. This material has flexible teeth allowing maximum comfort.\n\n*Each claw will have slight variations of color and pattern due to how the cellulose plates are cut during our production. \n*Actual colors may vary slightly from what appears online due to lighting and differences in monitors. ",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:41.390Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
